<ng-container *ngIf="isLoading; else pageContent">
  <div class="app-spinner">
    <mat-spinner></mat-spinner>
  </div>
</ng-container>

<ng-template #pageContent>
  <h2 class="create-account text-start ms-4">My Classrooms</h2>
  <p class="ms-4 sub-heading">
    view and manage all classroom you're part of whether you created them or
    joined as a participant
  </p>
  <div
    class="d-flex flex-wrap align-items-center justify-content-between gap-4 mt-4 mb-4 px-4"
  >
<div class="search-container flex-grow-1 d-flex align-items-center">
      <mat-icon class="search-icon">search</mat-icon>
      <input
        matInput
        placeholder="search your classrooms here ..."
        [(ngModel)]="searchQuery"
        (ngModelChange)="onSearchQueryChange($event)"
        class="ms-2 w-100"
      />
    </div>

    <!-- <button  [matMenuTriggerFor]="menu" class="filter-box-button">
      <mat-icon>filter_list</mat-icon>
      <span class="filter-label ms-3">{{ getFilterLabel() }}</span>
    </button> for now we are not using this
	 -->

    <!-- <mat-menu #menu="matMenu" class="filter-menu">
      <mat-radio-group [(ngModel)]="selectedFilter" (change)="getClassroom()">
        <mat-radio-button value="all">All</mat-radio-button><br />
        <mat-radio-button value="created">Created</mat-radio-button><br />
        <mat-radio-button value="joined">Joined</mat-radio-button>
      </mat-radio-group>
    </mat-menu> -->

    <div class="d-flex gap-4">
      <button class="responsive-btn" (click)="openCreateClassDialog()">
        <mat-icon>add</mat-icon>
        <span class="btn-text">Create Class</span>
      </button>

      <!-- <button class="responsive-btn" (click)="openJoinDialogBox()">
        <mat-icon>person_add</mat-icon>
        <span class="btn-text">Join Class</span>
      </button> for now we are not using this... later we will used this-->
    </div>
  </div>

  <div class="classroom-grid bg-color px-4">
    <ng-container *ngIf="_classroom.length > 0; else Result">
      <div
        *ngFor="let class of _classroom"
        class="class-card"
        (click)="goToClassroomPage(class.id)"
      >
        <div class="card-image-wrapper">
          <img
            [src]="class?.cover_image_url"
            class="card-img-top"
            alt="classroom"
          />
          <mat-icon class="arrow-icon">arrow_forward</mat-icon>
        </div>
        <div class="card-content mt-2">
          <div class="d-flex justify-content-between align-items-center">
            <h3 class="card-title">
            <ng-container *ngIf="class.created_by === loggedInUserId; else notCreated">
				<mat-icon class="vertical-align-icon">edit</mat-icon>
			</ng-container>
				<ng-template #notCreated>
				<mat-icon class="vertical-align-icon">groups</mat-icon>
			</ng-template>
				{{ class.name || "N/A" }}</h3>
            <!-- <button class="students-btn d-flex align-items-center me-0 ms-auto mt-2">
                <mat-icon>people</mat-icon>
                 {{class.student_count}} 
				 we dont have total number of student here so for now we are hidding them
				</button>-->
            <ng-container *ngIf="class.created_by === loggedInUserId">
            <button
              mat-icon-button
              [matMenuTriggerFor]="menu"
              (click)="$event.stopPropagation()"
            >
              <mat-icon>more_vert</mat-icon>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="openEditDialog(class)">
                Edit
              </button>
              <button mat-menu-item (click)="onDeleteDialogBox(class.id)">
                Delete
              </button>
            </mat-menu>
			</ng-container>
          </div>
          <p class="card-subtitle text-start">{{ class.subject || "N/A" }}</p>
        </div>
      </div>
    </ng-container>
    <ng-template #Result> No classroom found</ng-template>
  </div>
</ng-template>